import { useQuery } from '@tanstack/react-query';
import type { ConnectedAssetsSummary } from '../types';

export default function useConnectedAssetsSummary() {
  return useQuery<ConnectedAssetsSummary>({
    queryKey: ['connected-assets', 'summary'],
  });
}
